import * as React from 'react';
export const UnstableContext = /*#__PURE__*/React.createContext({});